/*globals Sentry:false */

import AdvancedSearchM from "../model/recordm.model.advancedsearch";
import { ConfirmDialog } from '@cob/ui-genesis/helpers/cob.dialog.js';
import DefinitionSearchResultV from '../view/recordm.view.searchresult.definition.js';
import IndexedInstanceM from '../model/recordm.model.entity.indexedinstance.js';
import Ps from '../recordm.permissions.js';
import RecordmImporterP from './recordm.importer.presenter.js';
import SearchVisM from '../model/recordm.model.searchvisualization.js';
import UriBuilder from '../helpers/module.uribuilder.js';

import { sprintf } from 'sprintf-js';
import { wrapped } from '@cob/ui-genesis/helpers/cob.sentry.js';

import ui from '@cob/ui-genesis/cob.ui.js';
import utils from '@cob/ui-genesis/cob.utils.js';

// The "Presenter" responsible for showing the records
//
// $container: the jquery HTML wrapper for the enclosing element
//
var DefinitionSearchResultP = function(core, searchM, definitionM, visualizationGroupM, instanceActions, $container, confs) {

    var _entityKey = definitionM.getEntityKey(),
        _settingKey = definitionM.getSettingKey(),
        _activeVisualizationId,
        _activeVisualizationM = new SearchVisM(core, definitionM),
    // to keep the entityMs that we're currently showing
        _indexedInstancesM = {},
        _loadingKey = core.getLoadingKey();

    var hasViewDetaislPerm = core.hasPermission("module:view:instance.detail"),
        _hasPermToShareViews= core.hasPermission(Ps.VIEW_SHARE);

    const conf = {
        canPrint: true,
        canCreateNewRecord: definitionM.data._links && definitionM.data._links.instantiate,
        canDuplicate : definitionM.data._links && definitionM.data._links.instantiate,
        canImportRecords: definitionM.data._links && (definitionM.data._links.instantiate || definitionM.data._links.updateInstances),
        customImports: core.getCustomImports(definitionM.getName()),
        rowsPerPage: searchM.getRowsPerPage(),
        columns: {
            all: _activeVisualizationM.getColumns(),
            visible: _activeVisualizationM.getVisibleColumns()
        },
        autoHeight: true
    };

    utils.extend(conf, confs, true);

   (function(){
      // HACK: como o _activeVisualizationM é normalmente guardado entre pedidos, vamos obter daí a coluna de sort
      // Na verdade é um problema de design, porque o modelo da visualização tem uma realidade e o da pesquisa tem outra
      // mas neste momento parece ser a escolha certa. Há uma boa probabilidade de este código todo ser re-escrito.
      const sortedColumn = _activeVisualizationM.getSortedColumn();

      if(sortedColumn) searchM.sort(sortedColumn.column, sortedColumn.ascending);
   })();

    var _updateSearchResultViewColumns = function() {
        const fields = definitionM.getSearchableFields();
        const columns = utils.clone(fields);
        for (let i = 0; i < columns.length; i++) {
           // copy the formatters, so that they keep the original scope (from before beeing cloned)
           if (columns[i].formatter) {
              columns[i].formatter = fields[i].formatter;
           }
        }

        conf.columns = {
            all: columns,
            visible: _activeVisualizationM.getVisibleColumns(),
            sort: _activeVisualizationM.getSortedColumn()
        };

        _searchResultView.setColumns(conf.columns);
    };

    const customPresenter = {
        hasAdvancedSearch: function(){
            return (searchM instanceof AdvancedSearchM);
        },
        getAdvancedSearchParameters: function(){
            if(!this.hasAdvancedSearch()){
                return undefined;
            }

            return searchM.getSearchParameters();
        },
        getAdvancedSearchQueryString: function(searchParams){
            // If there are no given search parameters it should use the current advanced search parameters,
            // so we return undefined if this is called when using the simple search
            if(searchParams === undefined && !this.hasAdvancedSearch()){
                return undefined;
            }

            // If there are no given search parameters than return the current advanced search query string,
            // otherwise build a query string using the given search parameters
            return (searchParams === undefined
                ? searchM.getCurrentQuery()
                : AdvancedSearchM.buildSearchQuery(searchParams));
        }
    };

    var onVisualizationSettingsChanged = function(){
        _activeVisualizationM.updateTemporarySettingsCache();
    };

    var _searchResultView = new DefinitionSearchResultV(core, definitionM, $container, conf, {
        createNewRecordRequested: function() {
            core.navigateTo(UriBuilder.buildUriForCreateInstance(definitionM.data.id));
        },
        importRecordsRequested: function(label, name, customMsg){
            const defName = definitionM.getName();
            const url = UriBuilder.buildUriForImporter(defName, name);

            new RecordmImporterP(core, defName, label, customMsg).start(url);
        },
        moreRecordsClick: function() {
            core.showLoading(_loadingKey, 'Search Results Load More Start');

            searchM.loadMoreData();
        },
        getIndexedInstanceM: function(instanceId) {
            return _indexedInstancesM[IndexedInstanceM.entityKey + ":" + instanceId];
        },
        getInstanceActions: function(instanceId) {
            var indexedInstanceM = _indexedInstancesM[IndexedInstanceM.entityKey + ":" + instanceId];
            return instanceActions ? instanceActions.getInstanceActions(indexedInstanceM) : "";
        },
        canExecuteBatchAction: function(batchAction, instanceId) {
            const indexedInstanceM = _indexedInstancesM[IndexedInstanceM.entityKey + ":" + instanceId];
            return  (typeof batchAction.isAllowed == "function"
                && batchAction.isAllowed(definitionM, indexedInstanceM, { presenter: customPresenter } ));
        },
        executeInstanceAction: function(actionKey, instanceKey, instanceId) {
            var key = instanceKey + ":" + instanceId,
                indexedInstanceM = _indexedInstancesM[key];

            if (indexedInstanceM && instanceActions) {
                instanceActions.executeInstanceAction(actionKey, indexedInstanceM);
            }
        },
        executeBatchActionOnSelection: function(bActionKey, indexedInstanceIds) {
            var indexedInstancesM = indexedInstanceIds.map(function(instanceId) {
                return _indexedInstancesM[IndexedInstanceM.entityKey + ":" + instanceId];
            });

            if (indexedInstancesM && indexedInstancesM.length > 0 && instanceActions) {
                instanceActions.executeBatchActionOnDataset(bActionKey, definitionM.getId(), indexedInstancesM, {
                    visibleColumns: (bActionKey == "export"
                        ?_activeVisualizationM.getVisibleColumnsNamesEscaped()
                        :_activeVisualizationM.getVisibleColumnsNames()
                        ),
                    columnLabels: (bActionKey == "export"
                        ?_activeVisualizationM.getVisibleColumnsLabelsEscaped()
                        :_activeVisualizationM.getVisibleColumnsLabels()
                        ),
                    presenter: customPresenter
                });
            }
        },
        executeBatchActionOnQuery: function(bActionKey) {
            var currentQuery = searchM.getCurrentQuery(true);

            if (!currentQuery || currentQuery === "") {
                currentQuery = "*";
            }

            if(instanceActions){
                instanceActions.executeBatchActionOnQuery(bActionKey, definitionM.getId(), currentQuery, {
                    visibleColumns: (bActionKey == "export"
                                     ?_activeVisualizationM.getVisibleColumnsNamesEscaped()
                                     :_activeVisualizationM.getVisibleColumnsNames()
                    ),
                    columnLabels: (bActionKey == "export"
                                   ?_activeVisualizationM.getVisibleColumnsLabelsEscaped()
                                   :_activeVisualizationM.getVisibleColumnsLabels()
                    ),
                    presenter: customPresenter
                });
            }
        },
        columnsVisibilityChanged: function(columns) {

            var columnsVisibilityChanged = false;

            columns.forEach(function(column) {

                    var changedColumn = definitionM.getSearchableField(column.fieldName);

                    if (changedColumn) {
                        _activeVisualizationM.setColumnVisibility(changedColumn, column.visibility);
                        onVisualizationSettingsChanged();

                        columnsVisibilityChanged = true;
                    }
                }
            );

            if (columnsVisibilityChanged) {
                _searchResultView.setViewStatus(
                    core.translateString("recordm.search", "visualization.column-visibility-changed")
                );

                _updateSearchResultViewColumns();
            }
        },
        columnWidthChanged: function(fieldName, width) {
            _activeVisualizationM.setColumnWidth(fieldName, width);
            onVisualizationSettingsChanged();

            _searchResultView.setViewStatus(
                core.translateString("recordm.search", "visualization.column-width-changed")
            );
        },
        columnOrderChanged: function(columns) {
            _activeVisualizationM.setColumnOrder(columns);
            onVisualizationSettingsChanged();

            _searchResultView.setViewStatus(
                core.translateString("recordm.search", "visualization.column-order-changed")
            );

        },
        sortColumns: function(fieldId, ascending) {
            core.showLoading(_loadingKey, 'Search Results Sort Start');

            searchM.sort(fieldId, ascending);

            _activeVisualizationM.setSortedColumn(fieldId, ascending);
            onVisualizationSettingsChanged();

            _searchResultView.setViewStatus(
                core.translateString("recordm.search", "visualization.sort-changed")
            );
        },
        selectionChanged: function(allSelected){
           const customizers = core.getListingCustomizers(definitionM.getName())
              .filter((customizer) => typeof customizer.onSelection === 'function');

           const selectedIds = _searchResultView.getSelectedResultsIds()

           core.publish("recordm:search-selection-changed", {
               allSelected:allSelected, query:searchM.getCurrentQuery() , selectedIds:selectedIds
           });

           // don't do anything if there's no one to call
           if (customizers.length == 0) return;

           let fullDatas = [];

           if(selectedIds.length > 0){
              const selectedResults = searchM.getSearchResults().filter((sr) =>  selectedIds.includes(sr.id))
              const selectedModels = selectedResults.flatMap((res) => core.getModels(res.modelKey))
              fullDatas = selectedModels.map((sm) => {
                 const data = sm.getFullData()
                 data.getValues = function(name){
                    const esFieldName = name.toLocaleLowerCase().replace((/ +/g), '_');
                    return this[esFieldName]
                 }
                 data.getValue = function(name){
                    const values = this.getValues(name)
                    return  values ? values[0] : undefined
                 }
                 return data;
              })
           }

           customizers.forEach((customizer) => wrapped(() =>  customizer.onSelection($container[0], fullDatas)));
        },
        saveCurrentView: function() {
            _searchResultView.askForViewName(_activeVisualizationM.getName());
        },
        viewNameConfirmed: function(name) {
            var existingVisualizationM = visualizationGroupM.getByName(name);

            if (existingVisualizationM) {
                if (!existingVisualizationM.isOwnedByUser()) {
                    ui.notification.showError(
                        core.translateString("recordm.search", "visualization.system-visualization-change-not-allowed")
                    );
                    return;
                }

                existingVisualizationM = _activeVisualizationM;

                _setActiveView(existingVisualizationM);
            } else {
                _activeVisualizationM.setName(name);
                _activeVisualizationM.setShared(false); //novas viz devem começar sempre unshared
            }

            _searchResultView.resetViewStatus();
            core.showLoading(_loadingKey, 'save view');

            visualizationGroupM.save(_activeVisualizationM);

            _activeVisualizationM.clearTemporarySettingsCache();
        },
        activateView: function(viewId, viewLabel) {
            var existingVisualizationM = visualizationGroupM.get(viewId),
                requiresNewSearch = false,
                currentSortedColumn,
                nextSortedColumn;

            if (!existingVisualizationM) {
                ui.notification.showError(
                    sprintf(core.translateString("recordm.search", "visualization.error-saving"), viewLabel)
                );
            } else {
                existingVisualizationM.resetTemporarySettingsToOriginal();

                currentSortedColumn = _activeVisualizationM.getSortedColumn();
                nextSortedColumn = existingVisualizationM.getSortedColumn();

                //   Situations that requires a new search:
                //   * no sort defined -> sort defined
                //   * sort defined -> no sort defined
                //   * sort column changes

                requiresNewSearch =
                    // * no sort defined -> sort defined
                (!currentSortedColumn && nextSortedColumn) ||
                    //   * sort defined -> no sort defined
                (currentSortedColumn && !nextSortedColumn) ||
                    //   * sort column changes
                (currentSortedColumn && nextSortedColumn && (
                    currentSortedColumn.column !== nextSortedColumn.column ||
                    currentSortedColumn.ascending !== nextSortedColumn.ascending));

                if (requiresNewSearch) {
                    // update the search as soon as possible
                    searchM.sort(
                        nextSortedColumn ? nextSortedColumn.column : undefined,
                        nextSortedColumn ? nextSortedColumn.ascending : undefined
                    );
                }

                _activeVisualizationM = existingVisualizationM.getCopy();

                _searchResultView.resetViewStatus();
                _setActiveView(_activeVisualizationM);
                _updateSearchResultViewColumns();
            }
        },
        deleteView: function(viewId) {
            var existingVisualizationM = visualizationGroupM.get(viewId);

            //TODO JF: Esta verificação é precisa? O botão de delete só aparece quando a visualização é do user loggado
            // Para além disso o backend também verifica isso antes de apagar a visualização, por isso
            // acho que isto é desnecessário
            if (!existingVisualizationM.isOwnedByUser()) {
                ui.notification.showError(
                    core.translateString("recordm.search", "visualization.system-visualization-delete-not-allowed")
                );
                return;
            }

            ConfirmDialog(core, {
                    message: sprintf(
                        core.translateString("recordm.search", "visualization.delete-question"),
                        existingVisualizationM.getName()
                    ),
                    confirmBtnLabel: core.translateString("recordm.search", "action.delete"),
                    confirmBtnClass: "btn-danger"
                },
                {
                    requestConfirmed: function() {
                        core.showLoading(_loadingKey, 'delete view');
                        visualizationGroupM.deleteView(parseInt(viewId, 10));
                    }
                });

        },
        shareView: function(viewId) {
            var visualizationM = visualizationGroupM.get(viewId);

            if(visualizationM){
                core.showLoading(_loadingKey, 'share view');
                visualizationM.share();
            }
        },
        unshareView: function(viewId) {
            var existingVisualizationM = visualizationGroupM.get(viewId);

            if(existingVisualizationM) {
                core.showLoading(_loadingKey, 'unshare view');
                existingVisualizationM.unshare();
            }
        },
        getFieldValue: function(resultData, fieldDef) {


            //We do not want to get the values from the Checkboxes or "Actions" columns
            if (fieldDef.entityField) {
                return resultData[fieldDef.field];
            } else {
                return undefined;
            }
        },
        onDetailsClicked: conf.onDetailsClicked
    });

    var _clearData = function() {
        _searchResultView.resetView();
    };

    var _showData = function() {

        var _searchResults = searchM.getSearchResults();

        var _newIndexedInstancesM = {},
        // a Latch that will fire after all the entityMs are available
            modelLoadLatch = new utils.CountdownLatch(_searchResults.length, function() {
                // Release previous laaded instances
                _releaseIndexedInstancesM(_indexedInstancesM);

                // Update our indexedInstancesM
                _indexedInstancesM = _newIndexedInstancesM;

                // Update the UI
                _updateViewData();

                // Update the batch actions available for this results
                _updateBatchActions();

            }, "model load");

        // we trigger loading the models for all the IDs that we received,
        // and subscribe to the updates
        _searchResults.forEach(function(result) {
            IndexedInstanceM.get(core, result.id, {
                success: function(indexedInstanceM) {
                    var indexedInstanceId = indexedInstanceM.data.id,
                        key = indexedInstanceM.getEntityKey() + ":" + indexedInstanceId;

                    // if not already loaded then subscrive for updates and deletes
                    if (!_indexedInstancesM[key]) {
                        core.subscribe(indexedInstanceM.update_event_name, _updateViewData);
                        core.subscribe(indexedInstanceM.delete_event_name, _onInstanceDeleted);
                    }

                    indexedInstanceM.uri = hasViewDetaislPerm
                        ? "#/" + UriBuilder.buildUriForInstance(indexedInstanceM.data.id)
                        : undefined;

                    //inject field definition descriptions
                    indexedInstanceM.fieldDescriptions = definitionM._getFieldsFlatten().map(function(field){
                       return {name:field.name, id:field.id ,desc:field.description};
                    });

                    //inject canDuplicateInstance check
                    indexedInstanceM.canDuplicateInstance = function(){
                        return conf.canDuplicate;
                    };

                    _newIndexedInstancesM[key] = indexedInstanceM;

                    modelLoadLatch.countDown("model:loaded:" + key);
                }
            });
        });

       core.publish('definition-search:results-ready');
    };

    var _updateViewData = function() {
        // everything's ready, let's show the new results
        var _indexedInstancesData = [];

        utils.forEachOwn(_indexedInstancesM, function(key) {
            _indexedInstancesData.push(_indexedInstancesM[key].getFullData());
        });

       const customizers = core.getListingCustomizers(definitionM.getName())
          .filter((customizer) => typeof customizer.onResults === 'function');

       if(customizers.length > 0) {
           const fullDatas = _indexedInstancesData.map((data) => {
              data.getValues = function(name){
                 const esFieldName = name.toLocaleLowerCase().replace((/ +/g), '_');
                 return this[esFieldName]
              }
              data.getValue = function(name){
                 const values = this.getValues(name)
                 return  values ? values[0] : undefined
              }
              return data;
           })

          const query = searchM._name === 'AdvancedSearchM'
             ? {type: 'Advanced', query: JSON.parse(searchM.getCurrentQuery())}
             : {type: 'Simple', query: searchM.getCurrentQuery()}

          customizers.forEach((customizer) => wrapped(() => customizer.onResults($container[0], fullDatas, query)))
       }

        _searchResultView.setTotalMatchingResults(searchM.getTotalMatchingResults());
        _searchResultView.showData(_indexedInstancesData);
    };

    var _updateBatchActions = function() {
        var results = [];

        utils.forEachOwn(_indexedInstancesM, function(key) {
            results.push(_indexedInstancesM[key]);
        });

        if(instanceActions){
            _searchResultView.updateBatchActions(
                instanceActions.getBatchActions(definitionM, results),
                instanceActions.getCustomBatchActions(definitionM, results, { presenter: customPresenter })
            );
        }
    };

    var _onInstanceDeleted = function(e, data) {
        var key = (data.entityKey + ":" + data.id),
            deletedInstanceM = _indexedInstancesM[key];

        searchM.removeFromSearchResult(deletedInstanceM);

        core.unsubscribe(deletedInstanceM.delete_event_name, _onInstanceDeleted);
        core.unsubscribe(deletedInstanceM.update_event_name, _updateViewData);

        delete _indexedInstancesM[key];

        deletedInstanceM.release();

        _updateViewData();
    };

    var _releaseIndexedInstancesM = function(indexedInstancesM) {
        utils.forEachOwn(indexedInstancesM, function(key) {
            indexedInstancesM[key].release();
        });
    };

    var _updateViews = function() {

        var currentVisualization = visualizationGroupM.get(
            _activeVisualizationId || _activeVisualizationM.getId()
        );

        _activeVisualizationId = undefined;

        if (currentVisualization) {
            _setActiveView(currentVisualization.getCopy());

            //only cache original if there isn't one (or else the original would be overwritten by the current view)
            if(!currentVisualization.hasOriginalSettingsCached()){
                currentVisualization.cacheOriginalSettings();
            }
        }

        var views = {
            active: {
                id: _activeVisualizationM.getId(),
                label: _activeVisualizationM.getName()
            },
            all: []
        };

        views.all = visualizationGroupM.getVisualizations().map(function(entry) {
            var viewOwner = entry.getOwner(),
                isOwnedByUser = entry.isOwnedByUser(),
                isShared = entry.isShared(),
                showOwner = !isOwnedByUser && !entry.isSystemSetting(),
                canShare = _hasPermToShareViews && isOwnedByUser;


            return {
                id: entry.getId(),
                label: entry.getName(),
                canDelete: isOwnedByUser,
                canShare: canShare,
                isShared: isShared,
                showOwner: showOwner,
                owner: viewOwner
            };
        });

        _searchResultView.setViewList(views);
        _updateSearchResultViewColumns();

        core.hideLoading(_loadingKey, 'update views');
    };

    var _updateViewList = function() {
        if(_activeVisualizationM.hasTemporarySettingsCached()){
            _searchResultView.setViewStatus(
                core.translateString("recordm.search", "visualization.has-unsaved-changes")
            );
        }else{
            _searchResultView.resetViewStatus();
        }
    };

    var _onViewDeleted = function(e, data) {
        var viewId = data.viewId;

        _searchResultView.removeView(viewId);

        // If the selected view is the same as the one beeing deleted
        // then unselect that view.
        if (_activeVisualizationM.getId() === viewId) {
            _activeVisualizationM.clearTemporarySettingsCache();
            _setActiveView(new SearchVisM(core, definitionM));
        }

        core.hideLoading(_loadingKey, 'delete view');
    };

    var _onViewShared = function(e, data){
        _onViewShareChanged(data.viewId, true);

        core.hideLoading(_loadingKey, 'share view');
    };

    var _onViewUnshared = function(e, data){
        _onViewShareChanged(data.viewId, false);

        core.hideLoading(_loadingKey, 'unshare view');
    };

    var _onViewShareChanged = function(viewId, isShared){
        _searchResultView.changeViewShareOption(viewId, isShared);
    };

    var _hideLoadingIndicator = function() {
        core.hideLoading(_loadingKey, 'Search Results end');
    };

    var _setActiveView = function(viewM) {
        _activeVisualizationM = viewM;

        _searchResultView.setActiveView({
            id: _activeVisualizationM.getId(),
            label: _activeVisualizationM.getName()
        });

        core.publish("recordm:search-view-changed:" + _settingKey, viewM.getId());
    };

    var _showSearchError = function(e, data) {
        var errorMsg = core.translateString("recordm.error.codes", "generic." + data.errorCode.toString())
            || core.translateString("recordm.error.codes", "search.error");

        ui.notification.showError(errorMsg);
    };

    var _subscribeEvents = function() {
        core.subscribe("recordm:search:finished", _hideLoadingIndicator);
        core.subscribe("recordm:search:finished", _showData);

        core.subscribe('recordm:search:error', _showSearchError);
        core.subscribe("recordm:search-reset:" + _entityKey, _clearData);

        core.subscribe("recordm:settings:" + _settingKey + ":views", _updateViewList);
        core.subscribe("recordm:settings:" + _settingKey + ":view-deleted", _onViewDeleted);
        core.subscribe("recordm:settings:" + _settingKey + ":view-shared", _onViewShared);
        core.subscribe("recordm:settings:" + _settingKey + ":view-unshared", _onViewUnshared);
        core.subscribe("recordm:settings:" + _settingKey + ":view-saved", _updateViews);
    };

    var _unsubscribeEvents = function() {
        core.unsubscribe("recordm:search:finished", _hideLoadingIndicator);
        core.unsubscribe("recordm:search:finished", _showData);

        core.unsubscribe('recordm:search:error', _showSearchError);
        core.unsubscribe("recordm:search-reset:" + _entityKey, _clearData);

        core.unsubscribe("recordm:settings:" + _settingKey + ":views", _updateViewList);
        core.unsubscribe("recordm:settings:" + _settingKey + ":view-deleted", _onViewDeleted);
        core.unsubscribe("recordm:settings:" + _settingKey + ":view-shared", _onViewShared);
        core.unsubscribe("recordm:settings:" + _settingKey + ":view-unshared", _onViewUnshared);
        core.unsubscribe("recordm:settings:" + _settingKey + ":view-saved", _updateViews);
    };

    return {
        init: function(query, activeVisualizationId) {
            _subscribeEvents();

            _searchResultView.start();

            core.showLoading(_loadingKey, 'viewP init');

            if (query === undefined) {
                _searchResultView.showWatermark();

            } else {
                _searchResultView.setSearchInProgressMode();
            }

            // Store the ID to load the visualization when available
            _activeVisualizationId = activeVisualizationId;

            _updateViews();
            _updateViewList();
        },
        resume: function() {
            _subscribeEvents();

            _searchResultView.start();

            if (searchM.getCurrentQuery()) {
                _updateViewData();
            }
        },
        pause: function() {
            _unsubscribeEvents();

            _searchResultView.stop();
        },
        destroy: function() {
            _unsubscribeEvents();
            _activeVisualizationM.clearTemporarySettingsCache();
            _searchResultView.stop();

            //release models
            _releaseIndexedInstancesM(_indexedInstancesM, []);
            _indexedInstancesM = {};
        },
        prepareView: function() {
            _searchResultView.refreshGrid();
        }
    };
};

export default DefinitionSearchResultP;
